









































































import { Component, Ref, Watch } from "vue-property-decorator";
import CreateClientConfigComponent from "@/components/combox/CreateClientConfig.vue";

import {
  getComBoxClientConfigInfo,
} from "@/data/repository/ClientRepository";
import { buildComBoxClientConfigInfo, ComBoxClientConfig, ComBoxClientConfigInfo } from "@/data/models/ComBoxClientConfig";
import { createDefaultHyDryDeviceSettings } from "@/data/models/Client";
import ConfirmationDialogComponent from "../common/ConfirmationDialog.vue";
import { defineOwnHyDryDeviceSettingsClientAccess } from "@/permissions/ClientPermissions";
import { HyDryDeviceSettings } from "@/data/models/Settings"
import { HyDryDeviceSettingsModule } from "@/store/modules/HyDryDeviceSettingsModule";
import { updateHyDryDeviceSettings } from "@/data/repository/SettingsRepository";
import { filterOutUndefined } from "@/utils/Utils";
import PickerDialogComponent from "../common/PickerDialog.vue";
import SettingsPageMixin from "@/components/settings/SettingsPageMixin";

@Component({
  components: {
    "create-client-config": CreateClientConfigComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    picker: PickerDialogComponent,
  },
})
export default class HyDryDeviceSettingsComponent extends SettingsPageMixin {
  isInitializing = true;

  initialHyDryDeviceSettings = createDefaultHyDryDeviceSettings();

  comBoxClientConfigInfo: ComBoxClientConfigInfo | undefined = undefined;
  miniClientConfigInfo: ComBoxClientConfigInfo | undefined = undefined;
  comBoxClientConfig: ComBoxClientConfig | undefined = undefined;
  minRunDurationForAnalysis = 15;

  clientConfigName = "";
  hasConfigurationChanged = false;

  alwaysShowSerialNumber = true;
  yesNoValues = [true, false];

  @Ref("createClientConfig")
  createClientConfig!: CreateClientConfigComponent;

  @Watch("hyDryDeviceSettings")
  onHyDryDeviceSettingsChanged() {
    if (this.hyDryDeviceSettings && !this.hyDryDeviceSettings.areDefaultHyDryDeviceSettings) {
      this.initializeParameters(this.hyDryDeviceSettings);  
    }
  }

  get hyDryDeviceSettings() {
    return HyDryDeviceSettingsModule.hyDryDeviceSettings;
  }

  get canEdit() {
    return defineOwnHyDryDeviceSettingsClientAccess();
  }

  get readonly() {
    return !this.isEditMode || !this.canEdit;
  }

  get hasChanged() {
    return (
      this.comBoxClientConfigInfo?.id !== this.initialHyDryDeviceSettings.comBoxClientConfigInfo?.id ||
      this.comBoxClientConfigInfo?.name !== this.initialHyDryDeviceSettings.comBoxClientConfigInfo?.name ||
      this.comBoxClientConfigInfo?.version !== this.initialHyDryDeviceSettings.comBoxClientConfigInfo?.version ||
      this.comBoxClientConfigInfo?.firmwareVersion !== this.initialHyDryDeviceSettings.comBoxClientConfigInfo?.firmwareVersion ||
      this.comBoxClientConfigInfo?.humidityUnit !== this.initialHyDryDeviceSettings.comBoxClientConfigInfo?.humidityUnit ||
      this.comBoxClientConfigInfo?.dataBase64 !== this.initialHyDryDeviceSettings.comBoxClientConfigInfo?.dataBase64 ||
      this.comBoxClientConfigInfo?.clientConfigVersion !== this.initialHyDryDeviceSettings.comBoxClientConfigInfo?.clientConfigVersion ||
      this.miniClientConfigInfo?.id !== this.initialHyDryDeviceSettings.miniClientConfigInfo?.id ||
      this.miniClientConfigInfo?.name !== this.initialHyDryDeviceSettings.miniClientConfigInfo?.name ||
      this.miniClientConfigInfo?.version !== this.initialHyDryDeviceSettings.miniClientConfigInfo?.version ||
      this.miniClientConfigInfo?.firmwareVersion !== this.initialHyDryDeviceSettings.miniClientConfigInfo?.firmwareVersion ||
      this.miniClientConfigInfo?.humidityUnit !== this.initialHyDryDeviceSettings.miniClientConfigInfo?.humidityUnit ||
      this.miniClientConfigInfo?.dataBase64 !== this.initialHyDryDeviceSettings.miniClientConfigInfo?.dataBase64 ||
      this.miniClientConfigInfo?.clientConfigVersion !== this.initialHyDryDeviceSettings.miniClientConfigInfo?.clientConfigVersion ||
      this.hasConfigurationChanged ||
      this.minRunDurationForAnalysis !== this.initialHyDryDeviceSettings.minRunDurationForAnalysis ||
      this.alwaysShowSerialNumber !== this.initialHyDryDeviceSettings.alwaysShowSerialNumber
    );
  }

  formatYesNo(value: boolean) {
    return this.$t(`common.${value ? "yes" : "no"}`).toString();
  }

  initializeParameters(
    hyDryDeviceSettings: HyDryDeviceSettings,
    keepEditMode?: boolean,
  ) {
    this.comBoxClientConfigInfo =
      hyDryDeviceSettings.comBoxClientConfigInfo;
    this.miniClientConfigInfo =
      hyDryDeviceSettings.miniClientConfigInfo;
    this.minRunDurationForAnalysis =
      hyDryDeviceSettings.minRunDurationForAnalysis ?? 15;
    this.alwaysShowSerialNumber =
      hyDryDeviceSettings.alwaysShowSerialNumber ?? true;

    this.initialHyDryDeviceSettings = {
      comBoxClientConfigInfo: this.comBoxClientConfigInfo,
      miniClientConfigInfo: this.miniClientConfigInfo,
      minRunDurationForAnalysis: this.minRunDurationForAnalysis,
      alwaysShowSerialNumber: this.alwaysShowSerialNumber,
    }

    this.hasConfigurationChanged = false;
    this.isEditMode = keepEditMode ?? false;
  }
  
  onHasConfigurationChanged(value: boolean) {
    this.hasConfigurationChanged = value;

    if (!this.hasConfigurationChanged) {
      this.initializeParameters(this.initialHyDryDeviceSettings, true);
    }
  }

  async onSetClientConfig() {
    const clientConfig = await this.createClientConfig.show(
      this.comBoxClientConfigInfo,
      this.hasConfigurationChanged,
      this.miniClientConfigInfo,
    );

    if (clientConfig) {
      this.comBoxClientConfig = clientConfig;
      this.comBoxClientConfigInfo = buildComBoxClientConfigInfo(
        clientConfig,
        "4.0.0",
        {
          isMini: false,
        },
      );

      const miniClientConfig: ComBoxClientConfig = {
        ...clientConfig,
        selectableDryingPrograms: clientConfig.selectableDryingProgramsMini,
        defaultControlConfig: {
          ...clientConfig.defaultControlConfig,
          dryingProgram: clientConfig.defaultDryingProgramMini,
        },
      };
      this.miniClientConfigInfo = buildComBoxClientConfigInfo(
        miniClientConfig,
        "0.0.1",
        {
          isMini: true,
        },
      );

      this.clientConfigName = clientConfig.name;
    }
  }

  async created() {
    this.isInitializing = true;

    const comBoxClientConfigInfo = getComBoxClientConfigInfo();
    const hyDryDeviceSettings = this.hyDryDeviceSettings;

    if (hyDryDeviceSettings && !hyDryDeviceSettings.areDefaultHyDryDeviceSettings) {
      this.initializeParameters(hyDryDeviceSettings);
    }
    else {
      this.initializeParameters({
        comBoxClientConfigInfo: comBoxClientConfigInfo
      });
    }

    this.isInitializing = false;
  }

  async doSave() {
    const update: HyDryDeviceSettings = {
      comBoxClientConfigInfo: this.comBoxClientConfigInfo,
      miniClientConfigInfo: this.miniClientConfigInfo,
      minRunDurationForAnalysis: this.minRunDurationForAnalysis,
      alwaysShowSerialNumber: this.alwaysShowSerialNumber
    }
    
    await updateHyDryDeviceSettings(
      filterOutUndefined(update)
    );

    this.initializeParameters(update);
  }

  mounted() {
    this.setToolbarTitle(this.$t("settings.hyDryDevice.configurations").toString());
  }
}
